// Constants
import { TaskGridColumnId } from "@ms/uno-constants/lib/local/TaskGridConstants";
// Models
import { ConditionalColoringOperator } from "./ConditionalColoringOperator";
// Utilities
import { getCustomFieldDefinitionId, isCustomFieldColumn } from "../../../../utilities/CustomFieldDefinitionUtilities";
/** Checks whether a value identifies a supported conditional-coloring column. */ export function isConditionalColoringColumnId(value) {
    if (typeof value !== "string") {
        return false;
    }
    switch(value){
        case TaskGridColumnId.Title:
        case TaskGridColumnId.Priority:
        case TaskGridColumnId.Status:
        case TaskGridColumnId.DueDate:
        case TaskGridColumnId.StartDate:
        case TaskGridColumnId.FinishDate:
        case TaskGridColumnId.Assignments:
        case TaskGridColumnId.Labels:
        case TaskGridColumnId.PercentComplete:
            return true;
        default:
            return isCustomFieldColumn(value) && getCustomFieldDefinitionId(value).length > 0;
    }
}
/** Checks whether a value is a known conditional-coloring operator. */ export function isConditionalColoringOperator(value) {
    switch(value){
        case ConditionalColoringOperator.Eq:
        case ConditionalColoringOperator.NtEqTo:
        case ConditionalColoringOperator.Gt:
        case ConditionalColoringOperator.Lt:
        case ConditionalColoringOperator.GtEqTo:
        case ConditionalColoringOperator.LtEqTo:
        case ConditionalColoringOperator.Between:
        case ConditionalColoringOperator.Contains:
        case ConditionalColoringOperator.DoesNotContain:
        case ConditionalColoringOperator.AssignedTo:
        case ConditionalColoringOperator.NotAssignedTo:
        case ConditionalColoringOperator.Empty:
            return true;
        default:
            return false;
    }
}
